import { CrmSearchFLPError } from '../CrmSearchError/CrmSearchFLPError';
import { CrmSearchQueryStringTooLongError } from '../CrmSearchError/CrmSearchQueryStringTooLongError';
import { CrmSearchFLPErrorEmptyState } from './CrmSearchFLPErrorEmptyState';
import { CrmSearchQueryStringTooLongErrorEmptyState } from './CrmSearchQueryStringTooLongErrorEmptyState';
import { CrmSearchUnknownErrorEmptyState } from './CrmSearchUnknownErrorEmptyState';
import { CrmSearchSortingOnFieldRestrictedError } from '../CrmSearchError/CrmSearchSortingOnFieldRestrictedError';
import { CrmSearchSortingOnFieldRestrictedErrorEmptyState } from './CrmSearchSortingOnFieldRestrictedErrorEmptyState';
import { CrmSearchCachingQueryTimeoutError } from '../CrmSearchError/CrmSearchCachingQueryTimeoutError';
import { CrmSearchTimeOutEmptyState } from './CrmSearchTimeOutEmptyState';
import { CrmSearch403ErrorEmptyState } from './CrmSearch403ErrorEmptyState';
import { CrmSearch403Error } from '../CrmSearchError/CrmSearch403Error';
import { CrmSearchStatus0Error } from '../CrmSearchError/CrmSearchStatus0Error';
import { CrmSearchStatus0ErrorEmptyState } from './CrmSearchStatus0ErrorEmptyState';
import { CrmSearch401Error } from '../CrmSearchError/CrmSearch401Error';
import { CrmSearch401ErrorEmptyState } from './CrmSearch401ErrorEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmSearchErrorEmptyState = ({
  error
}) => {
  if (error instanceof CrmSearchFLPError) {
    return /*#__PURE__*/_jsx(CrmSearchFLPErrorEmptyState, {
      error: error
    });
  }
  if (error instanceof CrmSearchQueryStringTooLongError) {
    return /*#__PURE__*/_jsx(CrmSearchQueryStringTooLongErrorEmptyState, {});
  }
  if (error instanceof CrmSearchSortingOnFieldRestrictedError) {
    return /*#__PURE__*/_jsx(CrmSearchSortingOnFieldRestrictedErrorEmptyState, {});
  }
  if (error instanceof CrmSearchCachingQueryTimeoutError) {
    return /*#__PURE__*/_jsx(CrmSearchTimeOutEmptyState, {});
  }
  if (error instanceof CrmSearch403Error) {
    return /*#__PURE__*/_jsx(CrmSearch403ErrorEmptyState, {});
  }
  if (error instanceof CrmSearchStatus0Error) {
    return /*#__PURE__*/_jsx(CrmSearchStatus0ErrorEmptyState, {});
  }
  if (error instanceof CrmSearch401Error) {
    return /*#__PURE__*/_jsx(CrmSearch401ErrorEmptyState, {});
  }
  return /*#__PURE__*/_jsx(CrmSearchUnknownErrorEmptyState, {});
};